









import Vue from 'vue'
import {Component} from "vue-property-decorator";

@Component
export default class NotFound extends Vue{
  count = 9;
  mounted(){
    this.load()
  }
  load(){
    const timeout = setInterval(()=>{
      if (this.count !== 0){
        this.count --;
      }else {
        this.$router.push('/money');
        window.clearInterval(timeout);
      }
    },1000)
  }
}
